import type React from 'react';
import { Gauge, Settings, HelpCircle, History, Code, PanelsTopLeft, ListChecks, Image, PaintBucket } from 'lucide-react';

// 路由元数据：用于侧边栏、导航栏和面包屑
export interface RouteMetaItem {
  path: string;            // 完整路径
  labelKey: string;        // 翻译 key（不含命名空间）
  icon?: React.ElementType;// 对应图标组件
  hidden?: boolean;        // 是否在导航中隐藏
}

export const routeMeta: RouteMetaItem[] = [
  // 上半部分（分隔线前）
  { path: '/canvas', labelKey: 'nav.routes.canvas', icon: PaintBucket },
  { path: '/storyboard', labelKey: 'nav.routes.storyboard', icon: PanelsTopLeft },
  { path: '/batch', labelKey: 'nav.routes.storyboardBatch', icon: ListChecks },
  // 下半部分（分隔线后）
  { path: '/dashboard', labelKey: 'nav.routes.dashboard', icon: Gauge },
  { path: '/history', labelKey: 'nav.routes.history', icon: History },
  { path: '/gallery', labelKey: 'nav.routes.gallery', icon: Image },
  { path: '/settings', labelKey: 'nav.routes.settings', icon: Settings },
  { path: '/help', labelKey: 'nav.routes.help', icon: HelpCircle },
  { path: '/develop/responseHandling', labelKey: 'nav.routes.responseHandling', icon: Code, hidden: true },
];

// 工具：根据路径获取标签
export const findLabelByPath = (path: string, translate?: (key: string) => string): string | undefined => {
  const item = routeMeta.find(r => r.path === path);
  if (!item) return undefined;
  const key = `layout:${item.labelKey}`;
  return translate ? translate(key) : key;
};
